export default __webpack_public_path__ + "static/media/20-fearful-face_1f628.60a44cc4.png";